import React from 'react';
import { decisionView } from './affordabilityView';

// The affordability check's decision on a loan (loans.affordability_decision:
// Approved / ManualReview / Declined) as a small badge, in the loan lists'
// status column. Nothing when the check was never run on the loan.
const AffordabilityBadge = ({ decision, className = '' }) => {
  const view = decisionView(decision);
  if (!view) return null;
  return (
    <span
      className={`px-2 py-0.5 inline-flex text-[11px] font-semibold border whitespace-nowrap ${view.style.badge} ${className}`}
      title={`Affordability check: ${view.label}`}
    >
      Affordability: {view.label}
    </span>
  );
};

export default AffordabilityBadge;
